"use client";

import { Amer25Schedule } from "~/data/amer25-data";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "components/ui/table";

const Schedule = () => {
  return (
    <div className="mb-0 bg-gradient-to-r from-blue-950 via-[#008793] to-[#A8EB12] pt-20 text-white">
      <h2 className="mb-12 px-6 text-center text-3xl">
        Join us at the following talks on Internet of Agents and Quantum
        Networking:
      </h2>
      <div className="w-full bg-black/30 backdrop-blur-md">
        <div className="container py-6 pb-16">
          {Amer25Schedule.map((date, i) => (
            <div className="py-3" key={i}>
              <h5 className="my-3 text-xl">{date.date}</h5>
              <div className="border-b"></div>
              <Table>
                <TableHeader className="border-0">
                  <TableRow className="border-0 border-b-0 text-lg">
                    <TableHead className="w-3/12 px-0 text-white">
                      Time
                    </TableHead>
                    <TableHead className="w-6/12 px-0 text-white">
                      Session Title
                    </TableHead>
                    <TableHead className="w-3/12 px-0 text-white">
                      Speaker
                    </TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {date.sessions.map((session, sid) =>
                    session.url ? (
                      <TableRow
                        className="cursor-pointer px-0 font-thin"
                        onClick={() =>
                          window?.open(
                            session.url,
                            "_blank",
                            "noopener,noreferrer",
                          )
                        }
                        key={sid}
                      >
                        <TableCell className="px-0 align-top text-base">
                          {session.time}
                        </TableCell>
                        <TableCell className="pl-0 align-top text-base">
                          {session.title}
                        </TableCell>
                        <TableCell className="px-0 align-top text-base">
                          {session.speaker}
                        </TableCell>
                      </TableRow>
                    ) : (
                      <TableRow key={sid} className="px-0 font-thin">
                        <TableCell className="px-0 align-top text-base">
                          {session.time}
                        </TableCell>
                        <TableCell className="pl-0 align-top text-base">
                          {session.title}
                        </TableCell>
                        <TableCell className="px-0 align-top text-base">
                          {session.speaker}
                        </TableCell>
                      </TableRow>
                    ),
                  )}
                </TableBody>
              </Table>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Schedule;
